module.exports = __webpack_public_path__ + "img/lcp_ux.87d1a969.svg";